import React from "react";
import { Link } from "react-router-dom";
import "./cta.css";

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <p>Free to use. No credit card required.</p>
      <h3>Start writing your paper today — research, references, and AI all in one place.</h3>
    </div>
    <div className="gpt3__cta-btn">
      <Link to="/authentication/sign-up" type="button">
        <button>Get Started Free</button>
      </Link>
    </div>
  </div>
);

export default CTA;
